import React from "react";
import Container from "../../Container/Container";
import Header from "../Header/Header";

function Shop() {
  return (
    <Container>
      <div>
        <Header />
      </div>
      <h2>Shop</h2>
    </Container>
  );
}

export default Shop;
